import { ChevronDown } from "@/components/Icons/utility/ChevronDown.tsx";
import { AgeSelect } from "@/components/Inputs/AgeSelect/AgeSelect.tsx";
import { CartAccommodationItem } from "@/stores/EngineStore/interfaces/CartAccommodationItem.ts";
import { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";

export const ChildrenAgeSelect = memo((props: { cartItem: CartAccommodationItem }) => {
  const { t } = useTranslation();

  const renderChildrenSelects = useMemo(() => {
    return props.cartItem.children?.map((child) => (
      <div className="c-be-select-wrapper" key={child.id}>
        <label className="c-be-select-label u-p1">{t("childAge")}</label>
        <div className="c-be-select-wrapper__inner">
          <AgeSelect person={child} isAdult={false} cartItemId={props.cartItem.id} />
          <ChevronDown />
        </div>
      </div>
    ));
  }, [props.cartItem, t]);

  if (!renderChildrenSelects.length) return null;

  return <div className="c-age-select">{renderChildrenSelects}</div>;
});

ChildrenAgeSelect.displayName = "ChildrenAgeSelect";
